import React from 'react';
import { Button, Modal } from '@cognitiv/cyprus-ui';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { useAppDispatch, useAppSelector } from 'ducks/hooks';
import { selectApiErrorModal } from 'ducks/modals/selectors';
import { setModal } from 'ducks/modals/slices';
import { selectSettings } from 'ducks/settings/selectors';
import { useSwitchTheme } from 'hooks/useSwitchTheme';
import { shallowEqual } from 'react-redux';

import cn from 'modals/utility/Utility.module.scss';
const { PUBLIC_URL } = process.env;

export const Errors = () => {
  const dispatch = useAppDispatch();
  const { theme } = useSwitchTheme();

  const api_error = useAppSelector(selectApiErrorModal, shallowEqual);
  const { status, name, error } = useAppSelector(selectSettings);

  const closeModal = async () => {
    dispatch(setModal({ api_error: false }));
  };

  return (
    <Modal
      margin="50px 0px 0px 0px"
      show={api_error}
      name="api_error"
      width={500}
      close_box={57}
      padding={20}
      onClose={closeModal}
      standard={false}
      custom_close_icon={faXmark}
      flex=""
    >
      <div>
        <div
          className={cn.headerWrapper}
          style={{
            color: theme.font_color,
            backgroundColor: theme.element_background,
            borderBottom: theme.border,
          }}
        >
          {status && <p>{status}:</p>}
          <p>{name || 'Something went wrong!'}</p>
        </div>
        <div className={cn.contentWrapper}>
          <img src={`${PUBLIC_URL}/empty-states-pc.svg`} alt="Cognitiv" />
          {!error && (
            <p className={cn.message}>
              Please close this popup and try accessing the page again. If the error persists please contact Cognitiv.
            </p>
          )}
          {error && <p className={cn.message}>{error}</p>}
        </div>
        <div className={cn.buttonsWrapper}>
          <Button width={115} button_size="medium" variant="blue" onClick={closeModal}>
            Ok
          </Button>
        </div>
      </div>
    </Modal>
  );
};
